<template>
  <sideBarView />

  <navbarView />

  <main class="main-sec" id="main">
    <div class="container">
      <div class="flex-bet-main mb-2">
        <div class="side-heading">
          <h6>{{ $t('technician.viewTitle') }}</h6>
          <p class="font13 gray-col">
            {{ $t('technician.viewSubtitle') }}
          </p>
        </div>
        <router-link to="/addTechnicain" class="main-btn up"
          >{{ $t('technician.addTechnicianBtn') }}</router-link
        >
      </div>
      <div v-if="!loader">

        <dataTable
          :tableData="filteredTechnicians"
          :showLink="false"
          :showEditRemove="true"
          :HeadOfTable="HeadOfTable"
          linkDirection="ownerDetails"
          @openModal="removeTichnicians"
        />
      </div>
      <div class="loader-main-axios" v-else>
        <div>{{ $t('technician.loadingData') }}</div>
        <div class="spinner-small-white"></div>
      </div>
    </div>
  </main>

  <!-- confirm modal  -->
  <Dialog v-model:visible="confirmRemove" modal :style="{ width: '520px' }">
    <div class="modal-body-main modal-pad">
      <div class="flex-group-me mb-4 mt-3">
        <img :src="dangerImg" class="successImg" alt="" />
      </div>
      <h6 class="font-bold text-center black font17 mb-4">
        {{ $t('technician.confirmDelete') }}
      </h6>
      <div class="flex-group-me mb-3">
        <button
          type="button"
          :disabled="disabled"
          class="main-btn lg up bg-red"
          @click="confirmRemoveFunc"
        >
          <div v-if="!disabled">{{ $t('technician.yesDelete') }}</div>
          <div class="loading" role="status" v-if="disabled">
            {{ $t('technician.deleting') }}
            <div class="spinner-small-white" v-if="disabled"></div>
          </div>
        </button>
        <button
          type="button"
          class="main-btn lg up bg-trans"
          @click="confirmRemove = false"
        >
          {{ $t('technician.cancel') }}
        </button>
      </div>
    </div>
  </Dialog>
  <!-- success modal  -->
  <Dialog v-model:visible="suceessRemove" modal :style="{ width: '520px' }">
    <div class="modal-body-main modal-pad">
      <div class="flex-group-me mb-4 mt-3">
        <img :src="successImg" class="successImg" alt="" />
      </div>
      <h6 class="font-bold text-center black font17 mb-4">
        {{ $t('technician.technicianDeletedSuccess') }}
      </h6>
      <div class="flex-group-me mb-3">
        <router-link
          to="/Techniciansview"
          @click="suceessRemove = false"
          class="main-btn lg up"
          >{{ $t('technician.techniciansLink') }}</router-link
        >
        <router-link to="/dashboardHome" class="main-btn lg up bg-trans"
          >{{ $t('technician.homeLink') }}</router-link
        >
      </div>
    </div>
  </Dialog>
</template>

<script setup>
// imports
import sideBarView from "../components/dashboard/sideBarView.vue";
import navbarView from "../components/dashboard/navbarView.vue";
import dataTable from "../components/dashboard/dataTable.vue";
import axios from "axios";
import { ref, onMounted, computed } from "vue";
import Dialog from "primevue/dialog";
import { useToast } from "primevue/usetoast";
import { useI18n } from "vue-i18n";
import { useStore } from 'vuex';

const toast = useToast();
const { t } = useI18n();
const store = useStore();

const suceessRemove = ref(false);
const confirmRemove = ref(false);
const successImg = ref(require("../assets/imgs/check.png"));
const dangerImg = ref(require("../assets/imgs/noun_warning.png"));
const workerId = ref(null);
const disabled = ref(false);

// reactive state
const HeadOfTable = ref([
  {
    headText: t('technician.serialNumber'),
    headKey: "id",
  },
  {
    headText: t('technician.technicianName'),
    headKey: "name",
  },
  {
    headText: t('technician.specializationField'),
    headKey: "maintenance_type.name",
  },
  {
    headText: t('technician.phoneNumber'),
    headKey: "phone",
  },
  {
    headText: t('technician.buildingCodesField'),
    headKey: "ref_codes",
  },
  {
    headText: t('technician.technicianRating'),
    headKey: "rate",
  },
]);

// computed properties
const filteredTechnicians = computed(() => store.getters.filteredTechnicians);
const loader = computed(() => store.getters.isLoading);
// const searchValue = computed(() => store.getters.searchValue);

// functions
const getWorkers = () => {
  store.dispatch('fetchTechnicians');
};

const removeTichnicians = (id) => {
  workerId.value = id;
  confirmRemove.value = true;
};

const confirmRemoveFunc = () => {
  disabled.value = true;

  axios
    .delete(`manager/delete-worker/${workerId.value}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then((response) => {
      if (response.data.key == "success") {
        suceessRemove.value = true;
        confirmRemove.value = false;
        getWorkers();
      } else {
        toast.add({
          severity: "error",
          detail: `${response.data.msg}`,
          life: 3000,
        });
      }
      disabled.value = false;
    });
};

// lifecycle hooks
onMounted(() => {
  getWorkers();
});
</script>
